class Sharey {
    constructor() {
        this.sharey = ".js-sharey-popup";
    }

    handelClick() {
        const popups = Array.from(document.querySelectorAll(this.sharey));
        popups.forEach(popup => {
            popup.addEventListener("click", e => {
                e.preventDefault();
                const url = e.target.href;
                window.open(
                    url,
                    "fbShareWindow",
                    "height=450, width=550, top=" +
                        (window.innerHeight / 2 - 275) +
                        ", left=" +
                        (window.innerWidth / 2 - 225) +
                        ", toolbar=0, location=0, menubar=0, directories=0, scrollbars=0"
                );
                return false;
            });
        });
    }

    init() {
        this.handelClick();
    }
}

export default Sharey;



// WEBPACK FOOTER //
// ../project/craft/src/components/sharey/sharey.js